import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Verification Instructions`}</h2>
    <p><strong parentName="p">{`IMPORTANT`}</strong>{`: Obtaining your `}<strong parentName="p">{`correct Verification ID`}</strong>{` (also known as "Random ID") is necessary to verify your integration when `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/dashboard/"
      }}>{`requesting a production API key`}</a></p>
    <p>{`Add and set the `}<inlineCode parentName="p">{`verificationMode`}</inlineCode>{` parameter to the `}<inlineCode parentName="p">{`configure`}</inlineCode>{` function like so:`}</p>
    <h3>{`iOS`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`Giphy.configure(apiKey: "your_api_key", verificationMode: true)
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-Objective-C"
      }}>{`[Giphy configureWithApiKey:@"your_api_key" verificationMode: true];
`}</code></pre>
    <h3>{`Android (v1.1.2 and later)`}</h3>
    <p>{`Run your app and your ID will be printed to the console. You will need to use this ID to complete the Verify GIPHY Integration step.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-Kotlin"
      }}>{`GiphyCoreUI.configure(context = yourContext, apiKey = "your_api_key", verificationMode = true)
`}</code></pre>
    <span />
    <h3>{`Web`}</h3>
    <p>{`To verify implementation of our `}<a href="https://github.com/Giphy/giphy-js/blob/master/packages/react-components/README.md">{`React SDK`}</a>{`
or `}<a href="https://github.com/Giphy/giphy-js/blob/master/packages/components/README.md">{`Javascript SDK`}</a>{` in your application
open your browser's console and paste in `}<inlineCode parentName="p">{`giphyRandomId`}</inlineCode>{` to get the value. This step is not needed if only using the `}<a href="https://github.com/Giphy/giphy-js/blob/master/packages/fetch-api/README.md">{`FetchAPI`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      